export enum StandardDataSourceIds {
  AddCommentOnEntity = 'addCommentOnEntity',
  AddReplyToEntityComment = 'addReplyToEntityComment',
  DeleteEntityComment = 'deleteEntityComment',
  FetchRepliesOfEntityComment = 'fetchRepliesOfEntityComment',
  FetchEntityComments = 'fetchEntityComments',
  FetchUserPreferences = 'fetchUserPreferences',
  UserPreferences = 'userPreferences',
  FetchCalendarEvents = 'fetchCalendarEvents',
}
